/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService
 */
import * as References from './PortalService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.simulation.environment.rpc.PortalService#createPortal
 */
export const CREATE_PORTAL_MUTATION_FIELD_NAME = 'com_hubspot_academy_simulation_environment_rpc_PortalService_createPortal';
export const CREATE_PORTAL_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_PORTAL_MUTATION_FIELD_NAME,
  args: ['exerciseId', 'sourcePortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.createPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});